import { render } from "./SidebarComp.vue?vue&type=template&id=ca021b50&scoped=true"
import script from "./SidebarComp.vue?vue&type=script&lang=js"
export * from "./SidebarComp.vue?vue&type=script&lang=js"

import "./SidebarComp.vue?vue&type=style&index=0&id=ca021b50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca021b50"]])

export default __exports__